import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import PublicInterviewShare from "./Pages/PublicInterviewShare/PublicInterviewShare";
import ListenInterviewShare from "./Pages/PublicInterviewShare/ListenInterviewShare";
import {
  fetchReview,
  reviewRoute,
} from "./Pages/PublicInterviewShare/reviewApi";

const route = reviewRoute(window.location.pathname, window.location.search);
// Start the API before React mounts; consume the promise once, without storing
// candidate data or share authorization in a persistent browser cache.
const initialRequest = route
  ? fetchReview(route.token).then(
      (data) => ({ data }),
      (error) => ({ error }),
    )
  : null;
const ApplicantAppRoot = React.lazy(() => import("./ApplicantAppRoot"));

class RootErrorBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    return this.state.failed ? (
      <main role="alert" style={{ padding: 32, fontFamily: "system-ui" }}>
        <h1>This page could not load</h1>
        <p>Please refresh to try again.</p>
        <button onClick={() => window.location.reload()}>Refresh page</button>
      </main>
    ) : (
      this.props.children
    );
  }
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <RootErrorBoundary>
    {route && route.listen ? (
      <ListenInterviewShare token={route.token} initialRequest={initialRequest} />
    ) : route ? (
      <PublicInterviewShare
        token={route.token}
        phone={route.phone}
        audioOnly={route.audioOnly}
        initialRequest={initialRequest}
      />
    ) : (
      <Suspense fallback={<main role="status">Loading…</main>}>
        <ApplicantAppRoot />
      </Suspense>
    )}
  </RootErrorBoundary>,
);
